import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { map, retry, tap } from 'rxjs/operators';
import { FilterParams } from './_state/bulk-pay.interfaces';
import { AuthHeaderService } from 'app/shared/auth-header.service';


@Injectable({
  providedIn: 'root'
})


export class BulkPayService {

    // Loading states
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  constructor(private http: HttpClient, private miscService: MiscService, private authHeaderService: AuthHeaderService) { }
  getRecipientsCategories(page: number = 1, limit: number = 5, searchTerm?: string, startDate?: string, endDate?: string) {
    const merchant_id = this.miscService.getMerchantDetails().merchant_id;

    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (searchTerm?.trim()) {
      params = params.set('search', searchTerm.trim());
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get(
      `${environment.API_URL}/v2/corporatepay/fetch/categories/${merchant_id}`,
      { params }
    ).pipe(retry(3));
  }




  getCountryProviders = (country_code) => this.http.get(`${environment.API_URL}/airtime/${country_code}`).pipe(retry(3))

  createRecipientsCategory = (requestBody) => this.http.post(`${environment.API_URL}/corporatepay/recipient/category`, requestBody)

  getRecipients = () => this.http.get(`${environment.API_URL}/corporatepay/${this.miscService.getMerchantDetails().merchant_id}`).pipe(retry(3))

  getRecipientsXAS = (page, limit, category_id, isSimilar?: boolean, search?: string) => {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("page", page.toString());
    params = params.append("category_id", category_id);
    if (isSimilar !== null && isSimilar !== undefined) {
      params = params.set("isSimilar", isSimilar.toString());
    }
    if (search && search.trim() !== "") {
      params = params.set("search", search.trim());
    }
    return this.http.get(
      `${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-recipient/${this.miscService.getMerchantDetails().merchant_id}`,
      { params }
    ).pipe(retry(3));
  }
  getStatusRecipientsXAS = (page, limit, reference, status?) => {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("page", page.toString());
    params = params.append("status", status);
    return this.http.get(`${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-log-recipient/${reference}/${this.miscService.getMerchantDetails().merchant_id}`, { params }).pipe(retry(3))
  }



  downloadFailedRecipientsXAS(
  reference: string
) {
  let params = new HttpParams()
    .set('status', 'failed')
    .set('export', 'true');

  const url = `${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-log-recipient/${reference}/${this.miscService.getMerchantDetails().merchant_id}`;

  return this.http.get(url, {
    params,
    responseType: 'blob'
  }).pipe(retry(3));
}

downloadSuccessfulRecipientsXAS(
  reference: string
) {
  let params = new HttpParams()
    .set('status', 'success')
    .set('export', 'true');

  const url = `${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-log-recipient/${reference}/${this.miscService.getMerchantDetails().merchant_id}`;

  return this.http.get(url, {
    params,
    responseType: 'blob'
  }).pipe(retry(3));
}


downloadPendingRecipientsXAS(
  reference: string
) {
  let params = new HttpParams()
    .set('status', 'pending')
    .set('export', 'true');

  const url = `${environment.API_URL3}/merchant/transactions/fetch-bulk-pay-log-recipient/${reference}/${this.miscService.getMerchantDetails().merchant_id}`;

  return this.http.get(url, {
    params,
    responseType: 'blob'
  }).pipe(retry(3));
}


  getStatusTransactionsXAS = (page, limit, status) => {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("page", page.toString());
    return this.http.get(`${environment.API_URL3}/merchant/transactions/bulk-pay/${status}/${this.miscService.getMerchantDetails().merchant_id}`, { params }).pipe(retry(3))
  }
  getRecipientLogData = (key) => {
    let params = new HttpParams();
    params = params.append("key", key);
    return this.http.get(`${environment.API_URL3}/merchant/transactions/dump`, { params }).pipe(retry(3))
  }
  checkBulkPayStatus = (ref, merchantId) => this.http.get(`${environment.API_URL3}/merchant/transactions/check-bulk-pay-status/${ref}/${merchantId}`).pipe(retry(3))

  inititateXasBulkPay = (payload) => this.http.post(`${environment.API_URL3}/merchant/transactions/bulk-pay`, payload)

  logRecipientData = (data) => this.http.post(`${environment.API_URL3}/merchant/transactions/dump`, data)

  getTotalAmount = (payload) => this.http.post(`${environment.API_URL3}/merchant/transactions/bulk-pay-amount`, payload)

  createRecipient = (requestBody) => this.http.post(`${environment.API_URL}/corporatepay/recipient`, requestBody)

  deleteRecipient = (recipientId) => this.http.delete(`${environment.API_URL}/corporatepay/${recipientId}`)

  getRecipientsByCategory = (categoryID) => this.http.get(`${environment.API_URL}/corporatepay/${categoryID}/${this.miscService.getMerchantDetails().merchant_id}`).pipe(retry(3))

  editRecipient = (requestBody) => this.http.put(`${environment.API_URL}/corporatepay/recipient`, requestBody)

  getRecipientBanks = (recipientCountryCode) => {


    if (recipientCountryCode === '044') {
      return of([]);
    } else {
      return this.http.get(`${environment.API_URL}/banks/${recipientCountryCode}`).pipe(retry(3))
    }
  }
getRecipientBanks2 = (recipientCountryCode: string) => {
     const xAuthHeader = this.authHeaderService.generateAuthHeader({});
          const headers = new HttpHeaders()
              .set('X-Auth-Signature', xAuthHeader)
              .set('X-APP-ID', `${environment.X_APP_ID}`)
              .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
  if (recipientCountryCode === 'GB') {
    return of([]);
  } else {
    return this.http
      .get(`${environment.API_URL3}/accounts/banks/${recipientCountryCode}`, { headers })
      .pipe(retry(3));
  }
};


  // validateXcelAccount = (walletNumber, schemeCode) => {
  //   return this.http.get(`${environment.API_URL}/source/details/${walletNumber}/${schemeCode}`).pipe(retry(3))
  // }

  updateTransactionStatus = (resource, transactionId, paymentId, status) => this.http.put(`${environment.MERCHANT_AUTH_URL}/api/update/${this.miscService.getMerchantDetails().merchant_id}/${transactionId}/${paymentId}/${status}`, resource)

  generateDLCode = (requestBody) => this.http.post(`${environment.ESA_URL}/otp/generate/dynamic-link`, requestBody)

  payRecipient = (requestBody, schemeCode) => {
    return this.http.post(`${environment.API_URL3}/merchant/transactions/payment`, requestBody)

  }

  getTopupTransactions = (external_ref, status) => this.http.get(`${environment.API_URL}/reports/transactions/status/${external_ref}/${status}/${this.miscService.getMerchantDetails().country_code}`)

  bulkDeleteRecipients = (payees: string[], categoryId: string) => {
    const payload = {
      payees: payees,
      categoryId: categoryId
    };

    return this.http.post(
      `${environment.API_URL3}/merchant/transactions/delete-bulk-pay`,
      payload
    ).pipe(retry(3));
  }

  getBulkPayReports(filters: FilterParams): Observable<any> {
    const merchant_id = this.miscService.getMerchantDetails().merchant_id;
    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params = params.set(key, filters[key]);
      }
    });

    const url = `${environment.API_URL3}/merchant/transactions/bulk-pay-reports/${merchant_id}`;
    return this.http.get<any>(url, { params }).pipe(retry(3));
  }


getAllTransactionDetails(
  reference: string,
  limit: number = 100,
  page: number = 1
): Observable<any> {


  if (!reference || reference.trim() === '') {
    throw new Error('Reference parameter is required and cannot be empty');
  }
  const successRequest = this.getStatusRecipientsXAS(page, limit, reference, 'success');
  const failedRequest = this.getStatusRecipientsXAS(page, limit, reference, 'failed');
  const pendingRequest = this.getStatusRecipientsXAS(page, limit, reference, 'pending');

  return forkJoin({
    success: successRequest,
    failed: failedRequest,
    pending: pendingRequest
  }).pipe(
    map((responses: any) => {
      
      const successData = responses.success?.data || { data: [], totalCount: 0 };
      const failedData = responses.failed?.data || { data: [], totalCount: 0 };
      const pendingData = responses.pending?.data || { data: [], totalCount: 0 };

      return {
        successful: {
          transactions: successData.data || [],
          totalCount: successData.totalCount || 0
        },
        failed: {
          transactions: failedData.data || [],
          totalCount: failedData.totalCount || 0
        },
        pending: {
          transactions: pendingData.data || [],
          totalCount: pendingData.totalCount || 0
        },
        summary: {
          successful: successData.totalCount || 0,
          failed: failedData.totalCount || 0,
          pending: pendingData.totalCount || 0,
          total: (successData.totalCount || 0) + (failedData.totalCount || 0) + (pendingData.totalCount || 0)
        }
      };
    }),
    retry(3)
  );
}

getTransactionDetailsByStatus(
  reference: string, 
  status: 'success' | 'failed' | 'pending',
  limit: number = 100,
  page: number = 1
): Observable<{transactions: any[], totalCount: number, currentPage: number, totalPages: number}> {
  
  if (!reference || reference.trim() === '') {
    throw new Error('Reference parameter is required and cannot be empty');
  }

  return this.getStatusRecipientsXAS(page, limit, reference, status).pipe(
    map((response: any) => {
      return {
        transactions: response.data?.data || [],
        totalCount: response.data?.totalCount || 0,
        currentPage: response.data?.currentPage || page,
        totalPages: response.data?.totalPages || 1
      };
    })
  );
}

recreateFailedTransactions(merchantId: string, categoryId: string, sessionId: string, transactionRefs: string[]): Observable<any> {
  return this.http.post(`${environment.API_URL}/corporatepay/create-failed-category/${merchantId}/${categoryId}`, {
    session_id: sessionId,
    transaction_ref: transactionRefs
  }).pipe(retry(3));
}

}